export default "__VITE_ASSET__DHm5ytcK__"